import React, {useEffect, useState} from "react";

import MenuSection from "./MenuSection";
export const Menu = (props) => {
  const menu = props.menu;
    const [pageNumber, setPageNumber] = useState(0);
    let pages = [];
    const makeCurrentPage = () =>{
        pages = Array.from(Array(menu.menu_sections.length).keys());
        return pages.slice(pageNumber, pageNumber+3 <=
        menu.menu_sections.length? pageNumber+3: menu.menu_sections.length);
    }
    const [currentNumber, setCurrentNumber] = useState(makeCurrentPage());
    const menuSection = currentNumber.map((num) =>
        <li className={"page-item " + (pageNumber === num ? " active" : "")}>
            <button className="page-link" onClick={() => handClickPage(num)} >{num+1}</button>
        </li>)
    const handleNextClick = () =>{
        let end = (currentNumber[currentNumber.length - 1] + 4) < pages.length ?
            (currentNumber[currentNumber.length - 1] + 4):(pages.length);
        let start = (currentNumber[currentNumber.length - 1] +1);
        setCurrentNumber(pages.slice(start, end))
        setPageNumber(currentNumber[0])
    }
    const handlePrevClick = () =>{
        let start = (currentNumber[0]-3>= 0?currentNumber[0]-3: 0);
        setCurrentNumber(pages.slice(start, start + 3))
        setPageNumber(currentNumber[0])
    }
    const handClickPage = (num)=>{
        console.log(num)
        setPageNumber(num)
    }

    const disableNext = () =>{
        if(currentNumber.length === 0 || (currentNumber.length > 0 &&
            pages[pages.length - 1] ===
            currentNumber[currentNumber.length - 1] )){
            console.log(currentNumber[currentNumber.length - 1])
            return  "disabled"
        }

        else return "";
    }
    useEffect(()=>{
        setPageNumber(currentNumber[0])
    },[currentNumber])
  return (
    <div className="row ms-4">

        <div className="col-12 col-lg-6 col-xl-6 col-xxl-6">
            <div className="row mb-4 mt-4">
                <nav aria-label="...">
                    <ul className={"pagination " +(pages.length <= 1? ' d-none ': '')}>
                        <li className={"page-item " + (currentNumber.length > 0 && 0 === currentNumber[0]? "disabled": "")}>
                            <button className="page-link" onClick={handlePrevClick} >Previous</button>
                        </li>
                        {menuSection}
                        <li className={"page-item " + disableNext()}>
                            <button className="page-link" onClick={handleNextClick} >Next</button>
                        </li>
                    </ul>
                </nav>
            </div>
            <MenuSection menuSection={menu.menu_sections[pageNumber]} />
        </div>
        <div className="col-lg-6 col-xl-6 col-xxl-6" />
    </div>
  );
};
